/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";
export function AbUnsetValue(props) {
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-unset-value", props));
}
//# sourceMappingURL=AbUnsetValue.js.map
